export class DeviceBasic {

    private active: boolean;
    private centerInternalId: string;
    private centerName: string;
    private deviceImage: string;
    private deviceModel: string;
    private deviceName: string;
    private deviceSerialNumber: string;
    private deviceTypeImage: string;
    private deviceTypeName: string;
    private internalId: string;
    private lastConnection: string;
    private locked: boolean;
    private status: string;
    private location: string;
    private mac: string;
    private ipAddress: string;
    private connectionDevice: string;
    private wifiSsid: string;
    private licenseInternalId: string;
    private licenseDescription: string;
    private remoteAccessConfigured: boolean;

    constructor(active?: boolean,
                centerInternalId?: string,
                centerName?: string,
                deviceImage?: string,
                deviceModel?: string,
                deviceName?: string,
                deviceSerialNumber?: string,
                deviceTypeImage?: string,
                deviceTypeName?: string,
                internalId?: string,
                lastConnection?: string,
                locked?: boolean,
                status?: string,
                location?: string,
                mac?: string,
                ipAddress?: string,
                connectionDevice?: string,
                wifiSsid?: string,
                licenseInternalId?: string,
                licenseDescription?: string,
                remoteAccessConfigured?: boolean
                ) {
                    this.active = active;
                    this.centerInternalId = centerInternalId;
                    this.centerName = centerName;
                    this.deviceImage = deviceImage;
                    this.deviceModel = deviceModel;
                    this.deviceName = deviceName;
                    this.deviceSerialNumber = deviceSerialNumber;
                    this.deviceTypeImage = deviceTypeImage;
                    this.deviceTypeName = deviceTypeName;
                    this.internalId = internalId;
                    this.lastConnection = lastConnection;
                    this.locked = locked;
                    this.status = status;
                    this.location = location;
                    this.mac = location;
                    this.ipAddress = location;
                    this.connectionDevice = location;
                    this.wifiSsid = location;
                    this.licenseInternalId = licenseInternalId;
                    this.licenseDescription = licenseDescription;
                    this.remoteAccessConfigured = remoteAccessConfigured;
                }

    public get Active() {
        return this.active;
    }
    public get CenterInternalId() {
        return this.centerInternalId;
    }
    public get CenterName() {
        return this.centerName;
    }
    public get DeviceImage() {
        return this.deviceImage;
    }
    public get DeviceModel() {
        return this.deviceModel;
    }
    public get DeviceName() {
        return this.deviceName;
    }
    public get DeviceSerialNumber() {
        return this.deviceSerialNumber;
    }
    public get DeviceTypeImage() {
        return this.deviceTypeImage;
    }
    public get DeviceTypeName() {
        return this.deviceTypeName;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get LastConnection() {
        return this.lastConnection;
    }
    public get Locked() {
        return this.locked;
    }
    public get Status() {
        return this.status;
    }
    public get Location() {
        return this.location;
    }
    public get Mac() {
        return this.mac;
    }
    public get IpAddress() {
        return this.ipAddress;
    }
    public get ConnectionDevice() {
        return this.connectionDevice;
    }
    public get WifiSsid() {
        return this.wifiSsid;
    }
    public get LicenseInternalId() {
        return this.licenseInternalId;
    }
    public get LicenseDescription() {
        return this.licenseDescription;
    }
    public get RemoteAccessConfigured(): boolean {
        return this.remoteAccessConfigured;
    }
    public set Active(active) {
        this.active = active;
    }
    public set CenterInternalId(centerInternalId) {
        this.centerInternalId = centerInternalId;
    }
    public set CenterName(centerName) {
        this.centerName = centerName;
    }
    public set DeviceImage(deviceImage) {
        this.deviceImage = deviceImage;
    }
    public set DeviceModel(deviceModel) {
        this.deviceModel = deviceModel;
    }
    public set DeviceName(deviceName) {
        this.deviceName = deviceName;
    }
    public set DeviceSerialNumber(deviceSerialNumber) {
        this.deviceSerialNumber = deviceSerialNumber;
    }
    public set DeviceTypeImage(deviceTypeImage) {
        this.deviceTypeImage = deviceTypeImage;
    }
    public set DeviceTypeName(deviceTypeName) {
        this.deviceTypeName = deviceTypeName;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set LastConnection(lastConnection) {
        this.lastConnection = lastConnection;
    }
    public set Locked(locked) {
        this.locked = locked;
    }
    public set Status(status) {
        this.status = status;
    }
    public set Location(location) {
        this.location = location;
    }
    public set Mac(mac) {
        this.mac = mac;
    }
    public set IpAddress(ipAddress) {
        this.ipAddress = ipAddress;
    }
    public set ConnectionDevice(connectionDevice) {
        this.connectionDevice = connectionDevice;
    }
    public set WifiSsid(wifiSsid) {
        this.wifiSsid = wifiSsid;
    }
    public set LicenseInternalId(licenseInternalId) {
        this.licenseInternalId = licenseInternalId;
    }
    public set LicenseDescription(licenseDescription) {
        this.licenseDescription = licenseDescription;
    }
}
